import * as Lambda from './LambdaApi';

export const linkAlexa = async (code, user, redirectUri = 'https://auto-login-speak2family.surge.sh/sso-redirect') => {
    const apiPath = `/sso`;

    const response = await Lambda.Post(
        apiPath,
        {
            code: code,
            redirectUri: redirectUri,
            user,
        },
        'lambda',
    );
    console.log('response:', response);
    return response;
};

export const linkAlexaFromAlexaApp = async (residentId) => {
    const apiPath = '/sso/residents/link';

    const { response } = await Lambda.Post(
        apiPath,
        {
            residentId,
        },
        'lambda',
    );

    console.log('response:', response);

    return response;
};

export const linkAlexaUsingInviteCode = async (inviteCode, code, redirectUri) => {
    const apiPath = '/sso/invites/link';
    const { response } = await Lambda.Post(
        apiPath,
        {
            inviteCode,
            code,
            redirectUri,
        },
        'lambda',
    );

    return response;
};
